import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Send, Copy, Check } from "lucide-react";
import SendEmailForm from './SendEmailForm';
import { useToast } from "@/hooks/use-toast";

interface SendEmailButtonProps {
  emailContent: string;
  userEmail?: string;
  currentView?: "preview" | "code";
}

const SendEmailButton: React.FC<SendEmailButtonProps> = ({ 
  emailContent, 
  userEmail,
  currentView = "preview" 
}) => {
  const [showSendModal, setShowSendModal] = useState<boolean>(false);
  const [copied, setCopied] = useState(false);
  const { toast } = useToast();

  if (!emailContent) return null;

  const handleCopyCode = async () => {
    try {
      await navigator.clipboard.writeText(emailContent);
      setCopied(true);
      toast({
        title: "Code kopiert!",
        description: "Der Code wurde in die Zwischenablage kopiert.",
      });
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast({
        title: "Fehler beim Kopieren",
        description: "Der Code konnte nicht kopiert werden.",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="relative">
      <Button 
        variant="default" 
        size="sm" 
        className="code-button h-8"
        onClick={() => setShowSendModal(true)}
      >
        <Send className="h-4 w-4 mr-2" />
        Senden
      </Button>

      {showSendModal && (
        <div className="absolute top-full right-0 mt-2 z-50 w-96 dark-glass rounded shadow-lg">
          <SendEmailForm 
            emailContent={emailContent}
            userEmail={userEmail}
            onCancel={() => setShowSendModal(false)}
            onEmailSent={() => setShowSendModal(false)}
            isInlineForm={true}
          />
        </div>
      )}
    </div>
  );
};

export default SendEmailButton;
